export default __webpack_public_path__ + "static/media/EmployeeTemplate.5f5b0e33.csv";